import React, { useCallback, useContext, useEffect, useState } from 'react';
import { IconSvg, colors } from '@ajaibid/components';
import useStockProfile from '@hooks/profile/useStockProfile';
import { formatCurrency } from '@ajaibid/utils';
import IconRP from '@assets/Icon/MenuProfile/svg/IconRP';
import ICON_SACK_OF_COINS from 'Icon/icon_sack_of_coins.png';
import ICON_INFO from 'Icon/MenuProfile/svg/IconInfo';
import IconDT from '@assets/Icon/MenuProfile/svg/IconDT';
import IconMT from '@assets/Icon/svg/IconMT';
import { DayTradingContext } from '@context/daytrading';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@context/auth';
import { MarginTradingContext } from '@context/marginTrading';
import { MENU } from '@screens/Rdn/constant';
import {
  styBPCard,
  styBPContainer,
  styBPTitleContainer,
  styBPTitleText,
  styIconInfo,
  styLabelIcon,
} from './style';
import PopupInfoBP from './PopupInfoBuyingPower';

const BuyingPower = () => {
  const navigate = useNavigate();
  const { buyingPowerStock, isErrorFetchBPStock } = useStockProfile();
  const {
    dtActive = false,
    dtTradeLimit = {},
    dtInProcess,
    isErrorFetchDTTradeLimit,
  } = useContext(DayTradingContext);
  const { buying_power: dtTradeLimitBp = 0 } = dtTradeLimit?.result || {};
  const {
    mtActive,
    mtInactive,
    mtProcess,
    mtRejected,
    emailVerified,
    userNotKycYet,
    stockKycVerified,
    stockKycError,
  } = useContext(AuthContext);
  const { mtTradeLimit, fetchMarginTradeLimit } = useContext(MarginTradingContext);
  const isErrorFetchMT = mtTradeLimit?.err_code !== 'EC0000000';

  const bpMarginTrade = mtTradeLimit.result?.margin_bp || 0;
  const [infoState, setInfoState] = useState({
    isOpen: false,
    img: null,
    title: '',
    content: '',
  });

  const hideInfo = useCallback(() => {
    setInfoState({ ...infoState, isOpen: false });
  });

  useEffect(() => {
    if (mtActive) {
      fetchMarginTradeLimit();
    }
  }, [mtActive, fetchMarginTradeLimit]);

  return (
    <>
      <PopupInfoBP info={infoState} hideModal={hideInfo} />
      {emailVerified && stockKycVerified && !stockKycError && (
        <div className={styBPContainer}>
          <div className={styBPTitleContainer}>
            <div className={styBPTitleText}>Buying Power</div>
            <div
              className={styIconInfo}
              onClick={() => {
                setInfoState({
                  isOpen: true,
                  img: ICON_SACK_OF_COINS,
                  title: 'Buying Power',
                  content:
                    'Dana yang dapat digunakan untuk membeli saham. Buying power akan berkurang jika kamu memasukkan order beli. Buying power akan bertambah ketika order beli dibatalkan/tidak selesai, atau ketika order jual sudah selesai.',
                });
              }}
            >
              <ICON_INFO />
            </div>
          </div>
          <div className={styBPCard}>
            <div>
              <div className={styLabelIcon}>
                <IconRP />
                <span style={{ color: colors.NEUTRAL_7 }}>Regular</span>
              </div>
              {isErrorFetchBPStock ? (
                <span style={{ color: colors.RED_6 }}>Dalam Pemeliharaan</span>
              ) : (
                <div className={styBPTitleText} style={{ fontWeight: 700 }}>
                  <span>{formatCurrency(buyingPowerStock, 'IDR')}</span>
                </div>
              )}
            </div>
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => navigate('/rdn', { state: { tabMenu: MENU.SETTLEMENT } })}
            >
              <IconSvg.Chevron.Right />
            </div>
          </div>

          <div className={styBPCard}>
            <div>
              <div className={styLabelIcon}>
                <IconDT />
                <span style={{ color: colors.NEUTRAL_7 }}>Day Trading</span>
              </div>
              {dtActive && isErrorFetchDTTradeLimit ? (
                <span style={{ color: colors.RED_6 }}>Dalam Pemeliharaan</span>
              ) : (
                <div className={styBPTitleText} style={{ fontWeight: 700 }}>
                  {!dtActive && !dtInProcess && (
                    <span
                      style={{ color: colors.AJAIB_BLUE_5, cursor: 'pointer' }}
                      onClick={() => navigate('/day-trading')}
                    >
                      Transfer
                    </span>
                  )}
                  {dtInProcess && (
                    <span
                      style={{ color: colors.YELLOW_6, cursor: 'pointer' }}
                      onClick={() => navigate('/day-trading')}
                    >
                      Sedang diproses
                    </span>
                  )}
                  {dtActive && <span>{formatCurrency(dtTradeLimitBp, 'IDR')}</span>}
                </div>
              )}
            </div>
            <div onClick={() => navigate('/day-trading')} style={{ cursor: 'pointer' }}>
              <IconSvg.Chevron.Right />
            </div>
          </div>

          {!userNotKycYet && (
            <div className={styBPCard}>
              <div>
                <div className={styLabelIcon}>
                  <IconMT />
                  <span style={{ color: colors.NEUTRAL_7 }}>Margin</span>
                </div>
                {isErrorFetchMT && mtActive ? (
                  <span style={{ color: colors.RED_6 }}>Dalam Pemeliharaan</span>
                ) : (
                  <div className={styBPTitleText} style={{ fontWeight: 700 }}>
                    {mtInactive && (
                      <span
                        style={{ color: colors.AJAIB_BLUE_5, cursor: 'pointer' }}
                        onClick={() => navigate('/margin-trading-onboarding')}
                      >
                        Aktifkan Sekarang
                      </span>
                    )}
                    {mtProcess && (
                      <span
                        style={{ color: colors.YELLOW_6, cursor: 'pointer' }}
                        onClick={() => navigate('/margin-trading-status')}
                      >
                        Sedang diproses
                      </span>
                    )}
                    {mtRejected && (
                      <span
                        style={{ color: colors.RED_6, cursor: 'pointer' }}
                        onClick={() => navigate('/margin-trading-status')}
                      >
                        Verifikasi Gagal
                      </span>
                    )}
                    {mtActive && <span>{formatCurrency(bpMarginTrade, 'IDR')}</span>}
                  </div>
                )}
              </div>
              <div onClick={() => navigate('/margin-trading')} style={{ cursor: 'pointer' }}>
                <IconSvg.Chevron.Right />
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default BuyingPower;
